export const ApckSelectDialog = {
    props: {
        label: {
            type: String,
            default: ""
        },
        message: {
            type: String,
            default: ""
        },
        options: {
            type: Array,
            default: []
        },
    },
    data() {
        return {
            newValue: ""
        }
    },
    methods: {
        accept() {
            const data = {};
            data.status = true;
            data.value = this.newValue;
            this.$emit('close', data);
        },
        deny() {
            const data = {};
            data.status = false;
            this.$emit('close', data);
        },
    },
    template: `
        <div class="alert-dialog">
            <p v-show="message">{{message}}</p>
            <apck-field>
                <apck-select
                    v-model="newValue"
                    :show-label="false"
                    :options="options"
                />
            </apck-field>
            <div class="pull-right">
                <span class="btn-positive btn-short btn" v-on:click="accept">OK</span>
                <span class="btn-negative btn-short btn" v-on:click="deny">Cancel</span>
            </div>
        </div>
    `
}
